module.exports = __webpack_public_path__ + "static/travolta-4a06efb5a2f39feaa2f81b9f3d179a94.gif";